import "./numberbox.css";

function NumberBox(props: {
  title: string;
  value: number | string;
  backColor: string;
  url: string;
}) {
  const urlPath = `https://fishweb.salmonesdechile.com/${props.url}`;
  return (
    <div
      style={{ backgroundColor: `var(${props.backColor})` }}
      className="numberbox"
      onClick={() => (window.location.href = urlPath)}
    >
      <span style={{ textAlign: "center", height: "25%", fontSize: "0.8vw" }}>
        {props.title}
      </span>
      <span style={{ fontSize: "3vw", fontWeight: "bold", height: "75%" }}>
        {props.value}
      </span>
    </div>
  );
}

export default NumberBox;
